import { APIResponse } from "@/types";
import { removeEmptyProps } from "@/utils/constants";
import AXIOS from "@/axios";
import {
  NotificationModel,
  NotificationQuery,
} from "@/types/notification.model";

export const getAllNotificationService = async (query: NotificationQuery) => {
  return AXIOS.get<APIResponse<NotificationModel>>(`/notify/api/v1/list`, {
    params: removeEmptyProps(query),
  });
};

export const bulkUpdateNotification = ({
  isRead,
  isClear,
  notificationId,
}: {
  isRead?: boolean;
  isClear?: boolean;
  notificationId?: string;
}) => {
  return AXIOS.get<APIResponse<NotificationModel>>(
    `/notify/api/v1/bulk-action`,
    {
      params: removeEmptyProps({ isRead, isClear, notifyId: notificationId }),
    }
  );
};

// notify/api/v1/mark-viewed
export const markNotificationAsRead = ({
  student_id,
  assignment_id,
  query_id,
}: {
  student_id?: string;
  assignment_id?: string;
  query_id?: string;
}) => {
  return AXIOS.post<APIResponse<NotificationModel>>(
    `/notify/api/v1/mark-viewed`,
    removeEmptyProps({ student_id, assignment_id, query_id })
  );
};
